export default "__VITE_ASSET__D$7LsJX___"